module.exports = __webpack_public_path__ + "images/6c9d9215e0d58ff634d059eabcca1474.svg";